import { useState } from "react";
import { RulesContent } from "./RulesContent";

// Hard reload (vs an in-app data refresh) so a stale tab also picks up any
// new client bundle and resets every transient piece of UI state. Used by
// both the refresh icon and the brand title.
function hardReload() { window.location.reload(); }

// `refresh` is no longer consumed by this component (both controls do a full
// page reload), but kept in the prop signature so existing callers don't break.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function TopBar({ refresh: _refresh }: { refresh: () => Promise<void> }) {
  const [rulesOpen, setRulesOpen] = useState(false);

  return (
    <>
      <header className="topbar">
        <div className="topbar__inner">
          <button type="button" className="topbar__brand" onClick={hardReload} aria-label="Refresh the app">
            DSK PickEm <span>- Daily</span>
          </button>
          <div className="topbar__actions">
            <button type="button" aria-label="Refresh scores" onClick={hardReload}>
              <svg viewBox="0 0 24 24"><path d="M20 6v5h-5M4 18v-5h5M18.4 10A7 7 0 0 0 6.2 7.2L4 11M5.6 14A7 7 0 0 0 17.8 16.8L20 13" /></svg>
            </button>
            <button type="button" aria-label="Open scoring rules" onClick={() => setRulesOpen(true)}>
              <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /><path d="M9.8 9a2.3 2.3 0 1 1 3.8 1.75c-1 .72-1.6 1.1-1.6 2.25M12 17h.01" /></svg>
            </button>
          </div>
        </div>
      </header>

      {rulesOpen && (
        <div className="rules-backdrop" role="presentation" onClick={() => setRulesOpen(false)}>
          <section className="rules-card" role="dialog" aria-modal="true" aria-labelledby="rules-title" onClick={(e) => e.stopPropagation()}>
            <button className="rules-card__close" type="button" aria-label="Close rules" onClick={() => setRulesOpen(false)}>×</button>
            <RulesContent />
          </section>
        </div>
      )}
    </>
  );
}
